<script setup>
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import DataTablesButtons from "datatables.net-buttons-bs5";
import DataTablesSelect from "datatables.net-select-bs5";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-fixedcolumns";
import useWindtagDevicesTable from "@/scripts/Devices/WindtagDevicesTable";
import ActionButtonsSection from "./WindTagActionButtons";
import { onBeforeRouteLeave } from "vue-router";

DataTable.use(DataTablesCore);
DataTable.use(DataTablesButtons);
DataTable.use(DataTablesSelect);

const {
  windtagDevicesColumns,
  tableOptions,
  onPageChange,
  handleSearch,
  handleSortChange,
  handleLengthChange,
  onSelect,
  onDeselect,
  tableData,
  resetTable,
} = useWindtagDevicesTable("totalDevices");

onBeforeRouteLeave((to) => {
  if (to.name === "archived-devices") {
    resetTable();
  }
});
</script>

<template>
  <div class="table-responsive">
    <div class="card-body">
      <ActionButtonsSection />

      <hr />
      <DataTable
        ref="dataTableRef"
        id="devices-table"
        :data="tableData"
        :columns="windtagDevicesColumns"
        :options="tableOptions"
        @page="onPageChange"
        @select="(event, dt, type) => onSelect({ event, dt, type })"
        @deselect="(event, dt, type) => onDeselect({ event, dt, type })"
        @length="(event, dt) => handleLengthChange({ event, dt })"
        @search="(event, dt) => handleSearch({ event, dt })"
        @order="(event, dt) => handleSortChange({ event, dt })"
        class="datatable-css table table-hover table-spacing text-nowrap"
        width="100%"
      >
      </DataTable>
    </div>
  </div>
</template>

<style>
.table-responsive {
  overflow-x: auto;
}
.table-spacing {
  margin: 5px 0 !important;
}
.datatable {
  margin: 10px;
}
button.dt-button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.datatable-css .dt-scroll-body {
  border-bottom-width: 0px !important;
}
</style>
